import { EFonts, EHovers } from 'libs/styles/styling';
import React from 'react';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    initialExpanded?: boolean;
    hasBorder?: boolean;
    children?: React.ReactNode;
    withHover?: boolean;
    withTopPadding?: boolean;
    noPadding?: boolean;
}

export const SidebarContent = (props: Props): JSX.Element => {
    return (
        <S_SidebarContent
            className={props.className}
            $hasBorder={props.hasBorder}
            $withHover={props.withHover}
            $withTopPadding={props.withTopPadding}
            $noPadding={props.noPadding}
        >
            {props.children}
        </S_SidebarContent>
    );
};

const S_SidebarContent = styled.div<{
    $hasBorder?: boolean;
    $withHover?: boolean;
    $withTopPadding?: boolean;
    $noPadding?: boolean;
}>`
    width: 100%;
    display: flex;
    padding: ${(props) => (props.$noPadding ? '0' : '0 15px 15px 15px')};
    color: #141c54;
    font-size: 13px;
    flex-direction: column;
    font-family: ${EFonts.Regular};
    border-bottom: ${(props) => (props.$hasBorder ? '1px solid #dadada' : 'none')};
    ${(props) => {
        if (props.$withHover) {
            return css`
                &:hover {
                    box-shadow: ${EHovers.LIGHT4};
                }
            `;
        }
    }}
    ${(props) => {
        if (props.$withTopPadding) {
            return css`
                padding-top: 15px;
            `;
        }
    }}
`;
